import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function MaintenanceType(props) {
    const { t } = useTranslation("translation");
    return (
        <Autocomplete
            multiple={props.multiple ? true : false}
            id="cpm_MaintenanceType_Autocomplete"
            value={props.selectedMaintenanceTypeName}
            defaultValue={""}
            style={props.style}
            onChange={(event, newValue) => {
                props.HandleMaintenanceTypeChange(newValue);
            }}
            disableCloseOnSelect
            options={props.maintenanceTypes.map((option) => option.name)}
            renderInput={(params) => <TextField id="cpm_TextField_4" {...params} margin="normal" label={t("MaintenanceType")} variant="outlined" />}
            size={props.size ?? "normal"}
        />
    );
}
